import { DomainType } from '../../../utilities/domain.utility';
import { ScimScope } from './scim.scope';

export const SCIM_SCOPE_DOMAIN: Record<ScimScope, DomainType> = {
    [ScimScope.Employee]: DomainType.Tenant,
    [ScimScope.Customer]: DomainType.ClientPortal,
    [ScimScope.Contractor]: DomainType.ContractorPortal,
};
